module.exports = __webpack_public_path__ + "assets/5-sales-director-jobs.fadcb555.png";